import React from 'react';
import { Link } from 'react-router-dom';
import { DEFAULT_DISABLED_BREADCRUMB_PATHS } from '@/settings';

export const createBreadCrumItemRenderHook = (disabledBreadCrumb) => {

  // eslint-disable-next-line react/prop-types,react/display-name
  return ({ path, breadcrumbName }) => {
    return (
      <Link to={(DEFAULT_DISABLED_BREADCRUMB_PATHS.includes(path) || disabledBreadCrumb?.includes(path)) ? false : path}
        disabled={DEFAULT_DISABLED_BREADCRUMB_PATHS.includes(path) || disabledBreadCrumb?.includes(path)}>{breadcrumbName}</Link>
    );
  };
};
